import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import { useLocalizedPath } from '@/lib/i18n/useLocale';
import 'swiper/css';

import Doc from '@/assets/svg/Doc';
import ElectricCar from '@/assets/svg/ElectricCar';
import CustomerFeedback from '@/assets/svg/CustomerFeedback';
import hrMangement from '../hrm/mainSection/svg/three.svg';

const carouselCardClass =
    'carousel-card flex justify-center items-center h-[110px] sm:h-[130px] lg:h-[160px] transition-all duration-500 rounded-3xl';

export default function ProductsCarousel() {
    const localizedPath = useLocalizedPath();
    const swiperRef = useRef<SwiperType | null>(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (swiperRef.current?.autoplay) {
                swiperRef.current.autoplay.start();
            }
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Swiper
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
            modules={[Autoplay]}
            initialSlide={1}
            centeredSlides
            slidesPerView={3}
            slidesPerGroup={1}
            spaceBetween={20}
            loop={true}
            loopAdditionalSlides={2}
            allowTouchMove={true}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                stopOnLastSlide: false,
                reverseDirection: false,
            }}
            speed={600}
            watchSlidesProgress
            className="products-carousel-swiper w-full max-w-[1000px] lg:max-w-[1100px] mx-auto !py-12 lg:!py-16"
        >
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath(`/crm`)} className="block h-full">
                    <div className={carouselCardClass}>
                        <CustomerFeedback />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath(`/hr-management`)} className="block h-full">
                    <div className={carouselCardClass}>
                        <img src={hrMangement} alt="hrMangement" className="w-full h-full object-contain" />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath('/products/3')} className="block h-full">
                    <div className={carouselCardClass}>
                        <ElectricCar />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath('/clinico')} className="block h-full">
                    <div className={carouselCardClass}>
                        <Doc />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath(`/crm`)} className="block h-full">
                    <div className={carouselCardClass}>
                        <CustomerFeedback />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath(`/products/3`)} className="block h-full">
                    <div className={carouselCardClass}>
                        <ElectricCar />
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="carousel-slide">
                <Link to={localizedPath('/clinico')} className="block h-full">
                    <div className={carouselCardClass}>
                        <Doc />
                    </div>
                </Link>
            </SwiperSlide>
        </Swiper>
    );
}
